var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGlobalMenu = function SvgGlobalMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "global_menu_svg__cls-2",
    d: "M12 11.2a.8.8 0 11-.8.8.8.8 0 01.8-.8zm3.2 0a.8.8 0 11-.8.8.802.802 0 01.8-.8zm-6.4 0a.8.8 0 11-.8.8.8.8 0 01.8-.8zM12 7.6a.8.8 0 11-.8.8.8.8 0 01.8-.8zm3.2 0a.8.8 0 11-.8.8.802.802 0 01.8-.8zm-6.4 0a.8.8 0 11-.8.8.8.8 0 01.8-.8zm3.2 7.2a.8.8 0 11-.8.8.8.8 0 01.8-.8zm3.2 0a.8.8 0 11-.8.8.802.802 0 01.8-.8zm-6.4 0a.8.8 0 11-.8.8.8.8 0 01.8-.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlobalMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "d061aee6764153d0e3f7901981e742fb.svg";
export { ForwardRef as ReactComponent };